// extracted by mini-css-extract-plugin
export default {"HtcContent":"HtcWidget_HtcContent__uc0gK","HtcWidget":"HtcWidget_HtcWidget__XPWdK","HtcImg":"HtcWidget_HtcImg__6zYAA"};